export const CERTIFICATION_TYPE = [
	{label: 'Certified General Appraiser', type: 'CertifiedGeneralAppraiser'},
	{label: 'Certified Residential Appraiser', type: 'CertifiedResidentialAppraiser'},
	{label: 'Licensed Residential Appraiser', type: 'LicensedResidentialAppraiser'},
	{label: 'Provisional Appraiser Trainee', type: 'ProvisionalAppraiserTrainee'},
	{label: 'Real Estate Agent Licensed', type: 'RealEstateAgentLicensed'},
	{label: 'Real Estate Broker Licensed', type: 'RealEstateBrokerLicensed'}
]